// extracted by mini-css-extract-plugin
export default {"searchForm":"search_searchForm__lDS2z","searchFormLabel":"search_searchFormLabel__G+d3i","searchFormBtnSearch":"search_searchFormBtnSearch__v4Tnk"};